import { createAction } from "@reduxjs/toolkit";
import { MODAL_SAGA_ACTION } from "constants/modal";
import type { ModalProps } from "types/modal";

export const modalActions = {
  OPEN_MODAL: createAction<ModalProps>(`${MODAL_SAGA_ACTION}/OPEN_REQUEST`),
  CLOSE_MODAL: createAction(`${MODAL_SAGA_ACTION}/CLOSE_REQUEST`),
};
